/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { getSocialShareProps } from "../../../utils";
import { SocialShare } from "@quintype/components";
import shareIcon from "../../../../assets/icons/social/shareicon.svg";
import closeIcon from "../../../../assets/icons/social/close.svg";
import { Popup } from "../../story-page-components/social-share/mobile-popup/popup";
import { breakpoint } from "../../../../utils/breakpoint";
import { getSocialShareData } from "./helper";

import "./share.module.css";
import { SvgHandler } from "../../svg-handler/svg-handler";

const ShareItem = ({ name, url, icon, dataTestId }) => (
  <li data-testid={dataTestId} styleName="icon">
    <a href={url} target="_blank" rel="noopener noreferrer" data-share-icon={name}>
      {icon}
    </a>
  </li>
);

ShareItem.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  icon: PropTypes.element,
  dataTestId: PropTypes.string
};

export class ShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showPopup: false
    };
  }

  toggle = event => {
    event.preventDefault();
    if (breakpoint("pc")) {
      this.setState(prevState => ({ showPopup: !prevState.showPopup }));
    } else {
      this.setState(prevState => ({ open: !prevState.open }));
    }
  };

  closePopup = () => this.setState({ showPopup: false });

  static getActionIcon(open, grey, greyShade, primaryColor) {
    const color = grey || !primaryColor ? greyShade : primaryColor;
    if (!open) return <SvgHandler width="24" height="24" clazzName="shareicon" xlinkHref={shareIcon} />;
    return <SvgHandler width="24" height="24" color={color} clazzName="closeicon" xlinkHref={closeIcon} />;
  }

  getDefaultStyle() {
    const { vertical, cardShare } = this.props;
    if (cardShare) return "wrapper card-share";
    if (vertical) return "wrapper vertical";
    return "wrapper";
  }

  render() {
    const { fbUrl, twitterUrl, linkedinUrl, whatsappUrl, grey, primaryColor, overrideStyles = false } = this.props;
    const greyShade = "#333";
    const defaultStyle = this.getDefaultStyle();
    const options = {
      fbUrl,
      twitterUrl,
      linkedinUrl,
      whatsappUrl,
      color: grey ? greyShade : ""
    };
    const greyColor = grey ? "grey-color-icons" : "";
    const iconsList = getSocialShareData(options);
    return (
      <div>
        <ul
          styleName={`${defaultStyle} ${greyColor} ${overrideStyles ? "override" : ""} ${
            this.state.open ? "open" : ""
          }`}
        >
          <li styleName="icon" key="horizontal-0">
            <a href="#" onClick={this.toggle}>
              {ShareTemplate.getActionIcon(this.state.open, grey, greyShade, primaryColor)}
            </a>
          </li>
          {iconsList.map((iconData, index) => (
            <ShareItem {...iconData} key={iconData.name} dataTestId={`card-share-${index}`} />
          ))}
        </ul>
        {this.state.showPopup && <Popup closePopup={this.closePopup} {...this.props} />}
      </div>
    );
  }
}

ShareTemplate.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  grey: PropTypes.bool,
  vertical: PropTypes.bool,
  cardShare: PropTypes.bool,
  primaryColor: PropTypes.string,
  overrideStyles: PropTypes.bool
};

export const Share = ({ story, config, grey = false, vertical = false, overrideStyles = false }) => {
  const socialShareProps = getSocialShareProps(config, story);
  return (
    <SocialShare
      template={ShareTemplate}
      grey={grey}
      fullUrl={encodeURI(story.url)}
      vertical={vertical}
      overrideStyles={overrideStyles}
      {...socialShareProps}
    />
  );
};

Share.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  grey: PropTypes.bool,
  vertical: PropTypes.bool,
  overrideStyles: PropTypes.bool
};
